<template>
  <div
    class="main--text">
    <v-row
      v-if="teacher && student"
      class="no--vertical--padding">
      <v-col
        md=4
        sm=4
        cols=12
        class="no--vertical--padding">
        <v-container
          fluid>
          <v-row
            justify=center
            justify-md=end
            justify-sm=end>
            <v-col
              cols=auto>
              <v-avatar
                size="111px">
                <img
                  :src="teacher.iconUrl"
                  alt=""
                  >
              </v-avatar>
            </v-col>
          </v-row>
          <div  style="text-align:right">
            <h2 :class="leftItemsStyle">{{ teacher.fullName() }}</h2>
            <p :class="leftItemsStyle">
              {{ teacher.flatFullName() }}<br>
              {{ teacher.genderInJapanese() }}<br>
              <v-tooltip
                left>
                <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  @click="message"
                  ><v-icon>far fa-comments</v-icon></v-btn>
                </template>
                <span>メッセージ画面を開く</span>
              </v-tooltip>
            </p>
          </div>
        </v-container>
      </v-col>
      <v-col
        md=8
        sm=8
        cols=auto>
        <v-container
          class="no--vertical--padding"
          fluid>
          <h5>対象のお子さま</h5>
          <p class="item--text">{{ student.fullName() }}さん</p>
          <h5>希望スケジュール</h5>
          <p class="item--text">{{ offer.lesson.schedule.toString() }}</p>
          <h5>一回あたり報酬</h5>
          <p class="item--text">{{ offer.lesson.wage }}円</p>
          <h5>依頼時コメント</h5>
          <p class="item--text line--feed">{{ offer.lesson.note }}</p>
        </v-container>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { TeacherRepository } from "@/repository/TeacherRepository"
import { StudentRepository } from "@/repository/StudentRepository"
import { firestore } from "@/repository/client/firestore"

export default {
  props: {
    offer: Object
  },
  data () {
    return {
      teacherRepo: null,
      studentRepo: null,
      teacher: null,
      student: null,
      leftItemsStyle: "text-center text-sm-right text-md-right"
    }
  },
  methods: {
    message () {
      this.$router.push({name: "parentMessages", params: {id: this.$store.getters.parent.uuid}})
    }
  },
  created: async function () {
    this.teacherRepo = new TeacherRepository(firestore)
    this.studentRepo = new StudentRepository(firestore)
    this.teacher = await this.teacherRepo.find(this.offer.receiverId)
    this.student = await this.studentRepo.find(this.offer.lesson.studentId)
  }
}
</script>

<style scoped>
.item--text {
  font-size: 1.1rem;
}

.no--vertical--padding {
  padding: 0px 12px;
}
</style>
